export default "__VITE_ASSET__BKFs0b5r__"